import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { DashboardService } from '../system/services/dashboard.service';
import { SessionService } from '../system/services/session.service';
import { events } from './models/events';
import { finances } from './models/finances';
import { opportunities } from './models/opportunities';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public spinnerMetrics = true;
  public errorMetrics = false;
  public metrica: any;
  public metricaMonth: any;
  public metricaLastMonth: any;
  public event: events;
  public finance: finances;
  public opportunities: opportunities;

  constructor(private dashboardService: DashboardService,
    private decimalPipe: DecimalPipe,
    private sessionService: SessionService,
    private currencyPipe: CurrencyPipe) { }

  ngOnInit() {
    this.getMetrics();
    this.getEvents();
    this.getFinances();
    this.getOpportunities();

    this.metrica = {
      investimentoTotal: 0,
      leadsGerados: 0,
      cpa: 0
    };
    this.metricaMonth = {
      investimentoTotal: 0,
      leadsGerados: 0,
      cpa: 0
    };
    this.metricaLastMonth = {
      investimentoTotal: 0,
      leadsGerados: 0,
      cpa: 0
    };

    this.event = {
      marcado: 0,
      realizado: 0,
      taxaComparencia: 0,
      marcadoMes: 0,
      realizadoMes: 0,
      taxaComparenciaMes: 0
    };

    this.finance = {
      valorRecebidoDia: 0,
      valorRecebidoMes: 0,
      porcentagemRecebidoMes: 0,
      porcentagemRecebidoMesPassado: 0
    };
    this.opportunities = {
      faturamentoLiquidoDay: 0,
      faturamentoLiquidoMonth: 0,
      quotaFechoDay: 0,
      quotaFechoMonth: 0,
      valorMedioMonth: 0
    };
  }

  async getMetrics() {
    try {
      this.spinnerMetrics = true;
      this.errorMetrics = false;
      const x: any = await this.dashboardService.getMetrics().pipe(take(1)).toPromise();
      this.metrica.leadsGerados = x.leads;


      const metricMonth: any = await this.dashboardService.getMetricsMonth().pipe(take(1)).toPromise();
      this.metricaMonth.leadsGerados = metricMonth.leads;


      const metricLastMonth: any = await this.dashboardService.getMetricsLastMonth().pipe(take(1)).toPromise();
      this.metricaLastMonth.leadsGerados = metricLastMonth.leads;

      this.spinnerMetrics = false;
    } catch (e) {
      this.spinnerMetrics = false;
      this.errorMetrics = true;
      console.error(e);
    }
  }

  async getEvents() {
    try {
      this.spinnerMetrics = true;
      this.errorMetrics = false;
      const x: any = await this.dashboardService.getDashboardEvents().pipe(take(1)).toPromise();

      this.event = x;
      this.spinnerMetrics = false;
    } catch (e) {
      this.spinnerMetrics = false;
      this.errorMetrics = true;
      console.error(e);
    }
  }

  async getFinances() {
    try {
      this.spinnerMetrics = true;
      this.errorMetrics = false;
      const x: any = await this.dashboardService.getDashboardFinances().pipe(take(1)).toPromise();

      this.finance.valorRecebidoDia = this.currencyPipe.transform((x.infoDay.totalRecebido + x.infoDay.totalRecebidoNao).toFixed(2), 'EUR', 'symbol', '.2');
      this.finance.valorRecebidoMes = this.currencyPipe.transform((x.infoMonth.totalRecebido + x.infoMonth.totalRecebidoNao).toFixed(2), 'EUR', 'symbol', '.2');
      // this.finance.porcentagemRecebidoMes = x.infoMonth.porcentagemRecebido;
      // this.finance.porcentagemRecebidoMesPassado = x.infoPreviousMonth.porcentagemRecebido;

      this.spinnerMetrics = false;
    } catch (e) {
      this.spinnerMetrics = false;
      this.errorMetrics = true;
      console.error(e);
    }
  }

  async getOpportunities() {
    try {
      this.spinnerMetrics = true;
      this.errorMetrics = false;
      const x: any = await this.dashboardService.getDashboardOpportunities().pipe(take(1)).toPromise();

      this.opportunities.faturamentoLiquidoDay = this.currencyPipe.transform(x.faturamentoLiquidoDay, 'EUR', 'symbol', '.2');
      this.opportunities.faturamentoLiquidoMonth = this.currencyPipe.transform(x.faturamentoLiquidoMonth, 'EUR', 'symbol', '.2');
      this.opportunities.quotaFechoDay = x.quotaFechoDay;
      this.opportunities.quotaFechoMonth = x.quotaFechoMonth;
      this.opportunities.valorMedioMonth = this.currencyPipe.transform(x.valorMedioMonth, 'EUR', 'symbol', '.2');


      const oppPorcentagem: any = await this.dashboardService.getDashboardOpportunitiesPorcentagem().pipe(take(1)).toPromise();
      this.finance.porcentagemRecebidoMes = oppPorcentagem.porcentagemTotalRecebidoMonth;
      this.finance.porcentagemRecebidoMesPassado = oppPorcentagem.porcentagemTotalRecebidoLastMonth;

      this.spinnerMetrics = false;
    } catch (e) {
      this.spinnerMetrics = false;
      this.errorMetrics = true;
      console.error(e);
    }
  }

  canDoAction(operation: string, path: any) {
    return this.sessionService.hasPermission(operation, path);
  }
}
